export const formatLegacyStorageUrl = (file: string): string =>
  `${import.meta.env.VITE_LEGACY_STORAGE_PATH}/${file}`
